module.exports = __webpack_public_path__ + "img/taketomi_9.a2ff996e.jpg";